import { render } from "./HeaderProfile.vue?vue&type=template&id=4a3393b4&scoped=true"
import script from "./HeaderProfile.vue?vue&type=script&lang=js"
export * from "./HeaderProfile.vue?vue&type=script&lang=js"

import "./HeaderProfile.vue?vue&type=style&index=0&id=4a3393b4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4a3393b4"]])

export default __exports__